import Game from './game';
import './style/index.css';

new Game('game');